export const Z_INDEX = {
  BASE: 1,
  FLOATING: 5,
  OVERLAY: 10,
  MODAL: 1000,
  CRITICAL: 10000,
} as const;
